import { useQuery } from '@apollo/client';
import { GET_CART_QUERY } from '../services';
// TODO consider moving this to a separate package
const useGetCart = ({
  id,
  currency,
  networkOnly = false,
  skip = false,
  cartData: currentCartData,
  ...rest
} = {}) => {
  // only fetch cart if id or currency has changed from the set cartData or vars not set yet
  // todo: see if we better use apollo cache for this
  let shouldSkip = skip || !id || !currency;
  if (currentCartData) {
    const idIsTheSame = currentCartData.id === id;
    const currencyIsTheSame =
      currentCartData.currency && currentCartData.currency.toLowerCase() === currency;
    if (idIsTheSame && currencyIsTheSame) shouldSkip = true;
  }
  const { data: { cartData } = {}, loading, error, refetch } = useQuery(GET_CART_QUERY, {
    variables: { currency, id },
    addTypename: false,
    fetchPolicy: networkOnly ? 'network-only' : 'cache-first',
    skip: shouldSkip,
    ...rest
  });

  return { loading, error, cartData, refetch };
};

export default useGetCart;
